import * as React from 'react';
import { PostData } from '../_fn';
import { useSelector, useDispatch } from 'react-redux';
import { alertSelect, alertUpdate } from '../_stores/slice/alert';


/**
 * Ajax 呼叫與狀態處理
 * ajaxStatus：true fasle
 * api：Api參數
 * setApiCode：設定狀態
 * setSuccess：成功時處理函式
 */
export function AjaxCom({setAjaxStatus, ajaxStatus, api, setApiCode, setSuccess}) {

  const dispatch = useDispatch();
  const alertStore = useSelector(alertSelect);


  const loadData = () => {

    setApiCode({
      loading: true,
      code: null,
      msg: null
    });

    const callback = (error, res) => {

      if(setAjaxStatus) {
        setAjaxStatus(false);
      }

      if(error) {
        console.log(`%ccallback error [${api.url}]`, 'color: #ff0000; font-weight: bold;', res);
        // let newAlertStore = {...alertStore};
        // newAlertStore.Snackbar.msg = `系統錯誤 [${api.url}] ${res.status === null ? '' : res.status} ${res.message}`;
        // newAlertStore.Snackbar.open = true;
        // newAlertStore.Snackbar.type = 'error';
        // dispatch(alertUpdate({
        //   ...newAlertStore
        // }));
      } else {
        console.log(`%ccallback res [${api.url}]`, 'color: #3faaf4; font-weight: bold;', res);
        setApiCode({
          loading: false,
          code: null,
          msg: null
        });
        setSuccess({res:res});
      }

    };
    PostData(api, callback);

  }

  React.useEffect(() => {
    if(ajaxStatus) {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ajaxStatus]);

  return null
}